import { A } from "components/A";
import { ReactNode } from "react";
import reactStringReplace from "react-string-replace";

export const linkify = (content: string | ReactNode[]) =>
  reactStringReplace(
    reactStringReplace(content, /(https?:\/\/\S+)/g, (match, i) => (
      <A key={i} href={match} target="_blank" rel="noreferrer">
        {match}
      </A>
    )),
    /(\r?\n\r?\n)/gm,
    (match, i) => (
      <span key={match.toString() + i} className="block h-[0.75em]" />
    ),
  );
